import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useNavigate } from 'react-router-dom';

import { ReactComponent as ErrorIcon } from '../../assets/images/error/404-icon.svg';

import './ErrorPage.styles.css';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleHome = () => {
        navigate('/')
    }

    return(
        <div className='cm-error-container cm-notfound-page-container d-flex align-items-center justify-content-center flex-column'>
            <ErrorIcon />
            <p className='text-blue-700 fw-bold fw-semibold pb-2 my-0'>{ t("page_not_found") }</p>
            <p className='my-0 text-center text-blue-gray-500 pb-2 fw-medium cm-sm-txt' style={{ maxWidth: '450px' }}>{ t("err_msg_404") }</p>
            <span className='text-blue-gray-400 cm-xs-txt'>{ t("error_code_404") }</span>
            <span className='cm-btn cm-trans-btn border border-action-blue text-action-blue cm-sm-txt mt-2 cm-pointer' onClick={handleHome}>{t("home")} <FontAwesomeIcon icon={regular("house")} className="ps-2" /></span>
            <Outlet />
        </div>
    )

}

export default NotFoundPage;